import compact from 'lodash/compact';
import SearchStorage from '@Services/SearchStorage';

async function mapper({ searchId }) {
  const pageName = 'Search results Preview';
  let title = '';
  const { query, structureUsed } = await SearchStorage.get(searchId);
  const structureStr = structureUsed ? 'structure' : undefined;
  const searchString = compact([`"${query}"`, structureStr]).join(' AND ');

  if (query && structureStr) {
    title = `Search results for ${searchString}`;
  } else if (query) {
    title = `Search results for "${query}"`;
  } else if (structureStr) {
    title = `Search results for ${structureStr}`;
  }

  return {
    title,
    pageName,
  };
}

export default mapper;
